import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><Link to="/about-us">About us</Link></li>
                <li><Link to="/app">Apps</Link></li>
                <li><Link to="/contact-us">Contact</Link></li>
              </ul>
            </div>
            <div className="footer-col">
              <h3 className="footer-title">Get In Touch</h3>
              <p className="footer-address">
                145 Quay Street<br />
                Auckland CBD<br />
                NZ
              </p>
              <p className="footer-tel"><a href="tel:+64211220200">+64 2112 20200</a></p>
              <p className="footer-email"><a href="mailto:chiechelski+leadingng@gmail.com">chiechelski+leadingng@gmail.com</a></p>
            </div>
            <div className="footer-col">
              <h3 className="footer-title">Map</h3>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/staticmap.png`}
                alt="Map - 145 Quay Street, Auckland CBD"
                className="footer-map"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-social">
            <a href="https://www.facebook.com/leadingng" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/leadingng" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>
          
          <div className="footer-ai-links">
            <span className="footer-ai-label">🤖 AI-Friendly:</span>
            <a href="/ai.json" target="_blank" rel="noopener noreferrer" title="Machine-readable company data">ai.json</a>
            <span className="footer-ai-separator">•</span>
            <a href="/skills.json" target="_blank" rel="noopener noreferrer" title="Detailed skills profile">skills.json</a>
            <span className="footer-ai-separator">•</span>
            <a href="/ai.md" target="_blank" rel="noopener noreferrer" title="AI-friendly docs">ai.md</a>
            <span className="footer-ai-separator">•</span>
            <a href="/humans.txt" target="_blank" rel="noopener noreferrer" title="Credits">humans.txt</a>
          </div>
          
          <p className="footer-copy">Copyright © {new Date().getFullYear()} LeadingNG</p>
        </div>
      </div>

      <style>{`
        .footer { background: #16202a; color: #9ca3af; }
        .footer-content { padding: 56px 0 32px; }
        .footer-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 40px;
        }
        .footer-title { color: #fff; font-size: 0.85rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; margin: 0 0 14px; }
        .footer-links { list-style: none; margin: 0; padding: 0; }
        .footer-links li { margin-bottom: 10px; }
        .footer-links a { color: #9ca3af; transition: color 0.2s ease; }
        .footer-links a:hover { color: var(--color-primary); }
        .footer-address, .footer-tel, .footer-email { margin: 0 0 10px; font-size: 0.95rem; line-height: 1.5; }
        .footer-map { max-width: 100%; height: auto; border-radius: var(--radius-sm); }
        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.08);
          padding: 24px 0;
          text-align: center;
        }
        .footer-social { display: flex; justify-content: center; gap: 20px; margin-bottom: 14px; }
        .footer-social a { color: #9ca3af; transition: color 0.2s ease; }
        .footer-social a:hover { color: var(--color-primary); }
        .footer-ai-links {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0;
          padding: 12px 20px;
          background: rgba(255, 255, 255, 0.03);
          border-radius: var(--radius-sm);
          font-size: 0.85rem;
        }
        .footer-ai-label {
          font-weight: 600;
          color: #fff;
          margin-right: 4px;
        }
        .footer-ai-links a {
          color: #6eb4d4;
          text-decoration: none;
          transition: all 0.2s ease;
          padding: 2px 6px;
          border-radius: 3px;
          font-family: 'Courier New', monospace;
        }
        .footer-ai-links a:hover {
          color: #fff;
          background: rgba(110, 180, 212, 0.15);
        }
        .footer-ai-separator {
          color: #4b5563;
          user-select: none;
        }
        .footer-copy { margin: 0; font-size: 0.9rem; opacity: 0.85; }
        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr; text-align: center; gap: 32px; }
          .footer-ai-links {
            font-size: 0.8rem;
            padding: 10px 16px;
            gap: 6px;
          }
          .footer-ai-label {
            width: 100%;
            margin-bottom: 4px;
          }
        }
      `}</style>
    </footer>
  );
}
